import { cn } from '@landing-blocks/shared/utils/cn/cn.js';

export const cnPriceBlock = cn('price-block');
